export default __webpack_public_path__ + "static/media/img6.953064ea.jpg";